import { FeatureCard } from '../ui/FeatureCard';
import { ArchitectureIcon, EvolutionIcon, QAIcon, AuthorIcon } from '../icons/FeatureIcons';

export function Features() {
  return (
    <section id="features" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-[#0969DA] tracking-wide uppercase">
            Features
          </h2>
          <p className="mt-1 text-3xl font-extrabold text-[#24292F] sm:text-4xl">
            Everything you need to onboard smoothly
          </p>
          <p className="mt-4 max-w-2xl text-xl text-[#57606A] lg:mx-auto">
            Our platform helps software engineers understand complex codebases faster and more effectively.
          </p>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <FeatureCard
            title="Architecture Visualization"
            description="Generate high-level architecture diagrams and detailed module/function relationships for better code understanding."
            icon={<ArchitectureIcon />}
          />
          <FeatureCard
            title="Code Evolution Analysis"
            description="Understand how the codebase has evolved over time with version history analysis and commit patterns."
            icon={<EvolutionIcon />}
          />
          <FeatureCard
            title="Interactive Q&A"
            description="Engage in contextual conversations to explore the codebase by asking targeted technical questions."
            icon={<QAIcon />}
          />
          <FeatureCard
            title="Author Expertise Mapping"
            description="Identify the most knowledgeable contributors for specific code modules and technical domains."
            icon={<AuthorIcon />}
          />
        </div>
      </div>
    </section>
  );
} 